<template>
    <div class="login">
        <div v-if="errorMessage" class="mb-6 mx-auto max-w-sm bg-red-100 border-l-4 border-red-500 text-red-700 p-4"
             role="alert">
            <p class="font-bold">Ocorreu um erro</p>
            <p v-text="errorMessage"></p>
        </div>
        <div v-if="infoMessage" class="mb-6 mx-auto max-w-sm bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4"
             role="alert">
            <p v-text="infoMessage"></p>
        </div>
        <form class="w-full max-w-sm mx-auto" @submit.prevent="signInOrCreateUser()">
            <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
                <div class="mb-4">
                    <label for="email" class="block text-gray-700 text-sm font-bold mb-2">Email</label>
                    <input id="email" type="email" v-model="email"
                           class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>
                </div>
                <div class="mb-6" v-if="forget === false">
                    <label for="password" class="block text-gray-700 text-sm font-bold mb-2">Senha</label>
                    <input id="password" type="password" v-model="password"
                           class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"/>
                </div>
                <div v-if="forget === false" class="flex items-center justify-between">
                    <button type="submit"
                            class="w-full md:w-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            :class="{'spinner': loading}">
                        Entrar
                    </button>
                    <a href="#" @click="forget = true"
                       class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800">
                        Esqueceu sua senha?
                    </a>
                </div>
                <div v-if="forget === true" class="flex flex-col">
                    <button type="submit" @click.prevent="forgetPassword()"
                            class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mt-6"
                            :class="{'spinner': loading}">Enviar email de recuperação
                    </button>
                    <a href="#" @click="forget = false"
                       class="inline-block align-baseline font-bold text-center text-sm text-blue-500 hover:text-blue-800 mt-6">
                        Possui um usuário? Entre aqui
                    </a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'Login',
        data() {
            return {
                errorMessage: '',
                infoMessage: '',
                forget: false,
                loading: false,
                email: '',
                password: ''
            }
        },
        methods: {
            newUserChange(value) {
                this.forget = false
                this.newUser = value
            },
            forgetPassword() {
                this.loading = true
                this.errorMessage = ''
                this.infoMessage = ''
                this.$store.dispatch('resetarSenha', this.email)
                    .then(() => {
                        this.infoMessage = "Um email de recuperação de senha foi enviado. Verifique sua caixa de mensagens."
                        this.newUserChange(false)
                    })
                    .catch(error => console.error(error))
                    .then(() => this.loading = false)
            },
            signInOrCreateUser() {
                this.loading = true
                this.errorMessage = ''
                this.infoMessage = ''
                this.$store.dispatch('autenticarUsuario', {email: this.email, password: this.password})
                    .then(() => this.$store.dispatch('obterFormularioSalvo', this.email))
                    .catch(error => this.errorMessage = error.message)
                    .then(() => this.loading = false)
            }
        }
    })
</script>